import styles from './PageHeader.module.scss'

export default function HeaderTextBlock({ children, style }) {
  return (
    <div className={styles.headerTextBlock} style={style}>
      {children}
    </div>
  )
}
